import { COMPLETE_CANCELLATION } from '../../constants/actions/policy';

export function completeCancellation(payload) {
    return {
        type: COMPLETE_CANCELLATION,
        payload,
    };
}
